/* tslint:disable:no-submodule-imports */
import Dropzone from "react-dropzone/dist/index";
export default Dropzone;
